// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import { FaEye, FaEyeSlash } from "react-icons/fa";  // <-- import icons
// import "./AuthPage.css";
// import SkeletonLoader from "../resuableComponents/SkeletonLoader";

// const AuthPage = () => {
//   const [tab, setTab] = useState("receptionist");
//   const [isLogin, setIsLogin] = useState(true);
//   const [showSuccess, setShowSuccess] = useState(false);
//   const [successMessage, setSuccessMessage] = useState("");
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     password: "",
//     confPassword: "",
//     phone: "",
//   });

//   // State to toggle password visibility
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfPassword, setShowConfPassword] = useState(false);

//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     const payload = {
//       ...formData,
//       userType: tab,
//     };

//     try {
//       const response = isLogin
//         ? await axios.post(`${process.env.REACT_APP_API_URL}login-user`, {
//             email: formData.email,
//             password: formData.password,
//           })
//         : await axios.post(
//             `${process.env.REACT_APP_API_URL}register-user`,
//             payload
//           );

//       const data = response.data;
//       // console.log("Response data:", data);

//       if (isLogin) {
//         localStorage.setItem("authData", JSON.stringify(data));
//         sessionStorage.setItem("token", data.accessToken);
//         sessionStorage.setItem("user", JSON.stringify(data.user));

//         if (data.user.userType === "doctor") {
//           sessionStorage.setItem("DoctorId", data.user._id);
//         } else if (data.user.userType === "receptionist") {
//           sessionStorage.setItem("ReceptionistId", data.user._id);
//         }

//         toast.success(data.message || "Login successful!");
//         setTimeout(() => {
//           navigate("/app/dashboard/");
//         }, 800);
//       } else {
//         toast.success("Registration successful! Please login now.");
//         setIsLogin(true);
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       toast.error(error.response?.data?.message || "Something went wrong");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <ToastContainer />
//       <div className="auth-page">
//         <span className="floating-shape shape-one" />
//         <span className="floating-shape shape-two" />

//         <div className="auth-shell">
//           <section className="auth-info-panel">
//             <div className="brand-pill">Ashtang Care</div>
//             <h1>
//               Seamless access to
//               <span> patient-first care</span>
//             </h1>
//             <p className="auth-subtext">
//               Log in to keep everything from appointments to billing moving
//               without friction. Switch to registration to onboard new teammates
//               in seconds.
//             </p>

//             <ul className="feature-list">
//               <li>Role-aware dashboards with instant context</li>
//               <li>Secure cloud sync across your devices</li>
//               <li>Realtime insights into patient flow</li>
//             </ul>

//             <div className="stat-grid">
//               <div className="stat-card">
//                 <span className="stat-value">1.2K+</span>
//                 <span className="stat-label">Daily patient touchpoints</span>
//               </div>
//               <div className="stat-card">
//                 <span className="stat-value">24/7</span>
//                 <span className="stat-label">On-call specialist access</span>
//               </div>
//             </div>
//           </section>

//           <section className="auth-content-panel">
//             {loading && <SkeletonLoader variant="overlay" />}

//             {showSuccess && (
//               <div className="success-popup">
//                 <p>{successMessage}</p>
//               </div>
//             )}

//             <div className="auth-card">
//               {!isLogin && (
//                 <div className="tabs">
//                   <button
//                     className={tab === "receptionist" ? "active" : ""}
//                     onClick={() => setTab("receptionist")}
//                     type="button"
//                   >
//                     Receptionist
//                   </button>
//                   <button
//                     className={tab === "doctor" ? "active" : ""}
//                     onClick={() => setTab("doctor")}
//                     type="button"
//                   >
//                     Doctor
//                   </button>
//                 </div>
//               )}

//               <div className="auth-box">
//                 <div className="card-heading">
//                   <p>{isLogin ? "Welcome back" : "Create an account"}</p>
//                   <h2>
//                     {isLogin
//                       ? "Sign in to Ashtang"
//                       : `Register as ${tab.charAt(0).toUpperCase() + tab.slice(1)}`}
//                   </h2>
//                 </div>

//                 <form onSubmit={handleSubmit}>
//                   {!isLogin && (
//                     <div className="inline-inputs">
//                       <input
//                         type="text"
//                         name="name"
//                         placeholder="Full Name"
//                         value={formData.name}
//                         onChange={handleChange}
//                         required
//                       />
//                       <input
//                         type="text"
//                         name="phone"
//                         placeholder="Phone"
//                         value={formData.phone}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                   )}
//                   <div className="input-field">
//                     <label>Email</label>
//                     <input
//                       type="email"
//                       name="email"
//                       placeholder="Enter your email"
//                       value={formData.email}
//                       onChange={handleChange}
//                       required
//                     />
//                   </div>

//                   <div className="input-field">
//                     <label>Password</label>
//                     <div className="password-input-wrapper">
//                       <input
//                         type={showPassword ? "text" : "password"}
//                         name="password"
//                         placeholder="Enter password"
//                         value={formData.password}
//                         onChange={handleChange}
//                         required
//                       />
//                       <span
//                         className="password-toggle-icon"
//                         onClick={() => setShowPassword(!showPassword)}
//                         style={{ cursor: "pointer" }}
//                       >
//                         {showPassword ? <FaEyeSlash /> : <FaEye />}
//                       </span>
//                     </div>
//                   </div>

//                   {!isLogin && (
//                     <div className="input-field">
//                       <label>Confirm Password</label>
//                       <div className="password-input-wrapper">
//                         <input
//                           type={showConfPassword ? "text" : "password"}
//                           name="confPassword"
//                           placeholder="Re-enter password"
//                           value={formData.confPassword}
//                           onChange={handleChange}
//                           required
//                         />
//                         <span
//                           className="password-toggle-icon"
//                           onClick={() => setShowConfPassword(!showConfPassword)}
//                           style={{ cursor: "pointer" }}
//                         >
//                           {showConfPassword ? <FaEyeSlash /> : <FaEye />}
//                         </span>
//                       </div>
//                     </div>
//                   )}

//                   <button type="submit" className="submit-btn" disabled={loading}>
//                     {loading ? "Processing..." : isLogin ? "Login" : "Register"}
//                   </button>
//                 </form>

//                 <p className="toggle">
//                   {isLogin
//                     ? "Don't have an account?"
//                     : "Already have an account?"}{" "}
//                   <span onClick={() => setIsLogin(!isLogin)}>
//                     {isLogin ? "Register" : "Login"}
//                   </span>
//                 </p>
//               </div>

//               <div className="support-note">
//                 Having trouble?{" "}
//                 <a href="mailto:support@ashtangcare.com">Contact support</a>
//               </div>
//             </div>
//           </section>
//         </div>
//       </div>
//     </>
//   );
// };

// export default AuthPage;

// src/Components/Credentials/AuthPage.jsx
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./AuthPage.css";
import SkeletonLoader from "../resuableComponents/SkeletonLoader";
import CustomDropdown from "../resuableComponents/CustomDropdown";
import BranchSelectionModal from "./BranchSelectionModal";
import ThemeToggle from "../../theme/ThemeToggle";

const BRANCH_REQUIRED_ROLES = ["doctor", "receptionist", "sales"];

const AuthPage = () => {
  const [role, setRole] = useState("receptionist");
  const [isLogin, setIsLogin] = useState(true);
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confPassword: "",
    phone: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfPassword, setShowConfPassword] = useState(false);

  const [loading, setLoading] = useState(false);
  const [showBranchModal, setShowBranchModal] = useState(false);
  const [pendingNavigateTo, setPendingNavigateTo] = useState(null);
  const navigate = useNavigate();
  // for contact mail
  const SUPPORT_EMAIL = "trivanta73@gmail.com";
  const SUBJECT = "Support Request – Ashtang Care";
  const BODY = `
Hello Support Team,

I need assistance regarding:

Name:
Role (Doctor / Receptionist / Admin):
Issue Description:

Thanks,
`;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Clear previous session data to ensure a clean login state
    localStorage.removeItem("authData");
    sessionStorage.clear();

    const payload = {
      ...formData,
      userType: role,
    };

    try {
      const response = isLogin
        ? await axios.post(`${process.env.REACT_APP_API_URL}login-user`, {
          email: formData.email,
          password: formData.password,
        })
        : await axios.post(
          `${process.env.REACT_APP_API_URL}register-user`,
          payload
        );

      const data = response.data;

      if (isLogin) {
        const isAdmin =
          data?.user?.userType === "admin" ||
          data?.user?.userType === "head" ||
          (data?.user?.email &&
            data.user.email.toLowerCase() === "admin@gmail.com");

        localStorage.setItem("authData", JSON.stringify(data));
        sessionStorage.setItem("token", data.accessToken);
        sessionStorage.setItem("user", JSON.stringify(data.user));

        if (data.user.userType === "doctor") {
          sessionStorage.setItem("DoctorId", data.user._id);
        } else if (data.user.userType === "receptionist") {
          sessionStorage.setItem("ReceptionistId", data.user._id);
        } else if (data.user.userType === "admin") {
          // Store admin ID if needed
          sessionStorage.setItem("AdminId", data.user._id);
        } else if (data.user.userType === "sales") {
          sessionStorage.setItem("SalesId", data.user._id);
        }

        toast.success(data.message || "Login successful!", {
          autoClose: 4000,
        });

        const destination = isAdmin
          ? "/app/admin-dashboard"
          : data.user.userType === "sales"
          ? "/app/sales-daily-report"
          : "/app/dashboard/";

        const needsBranch =
          BRANCH_REQUIRED_ROLES.includes(data.user.userType) && !data.user.branch;

        if (needsBranch) {
          setPendingNavigateTo(destination);
          setShowBranchModal(true);
        } else {
          // Trigger ripple transition then navigate
          setIsTransitioning(true);
          setTimeout(() => navigate(destination), 1500);
        }
      } else {

        // Registration successful - user needs admin approval
        toast.success(
          "Registration successful! Your account is pending admin approval. You will be able to login once approved.",
          {
            autoClose: 4000,
          }
        );
        setIsLogin(true);
      }
    } catch (error) {
      console.error("Error:", error);


      toast.error(error.response?.data?.message || "Something went wrong", {
        autoClose: 4000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleBranchModalComplete = () => {
    setShowBranchModal(false);
    setIsTransitioning(true);
    setTimeout(() => navigate(pendingNavigateTo), 1500);
  };

  return (
    <>
      {showBranchModal && (
        <BranchSelectionModal onComplete={handleBranchModalComplete} />
      )}
      <div className="auth-page">
        <ThemeToggle className="auth-theme-toggle" />
        {isTransitioning && (
          <div className="ripple-transition-overlay">
            <div className="ripple-bg" />
            <img src="/favicon.png" alt="Loading" className="spinning-favicon" />
          </div>
        )}
        <span className="floating-shape shape-one" />
        <span className="floating-shape shape-two" />

        <div className="auth-shell">
          <section className="auth-info-panel">
            <div className="brand-pill">Ashtang Care</div>
            <h1>
              Seamless access to
              <span> patient-first care</span>
            </h1>
            <p className="auth-subtext">
              Log in to keep everything from appointments to billing moving
              without friction. Switch to registration to onboard new teammates
              in seconds.
            </p>

            <ul className="feature-list">
              <li>Role-aware dashboards with instant context</li>
              <li>Secure cloud sync across your devices</li>
              <li>Realtime insights into patient flow</li>
            </ul>

            <div className="stat-grid">
              <div className="stat-card">
                <span className="stat-value">1.2K+</span>
                <span className="stat-label">Daily patient touchpoints</span>
              </div>
              <div className="stat-card">
                <span className="stat-value">24/7</span>
                <span className="stat-label">On-call specialist access</span>
              </div>
            </div>
          </section>

          <section className="auth-content-panel">
            {loading && <SkeletonLoader variant="overlay" />}

            {showSuccess && (
              <div className="success-popup">
                <p>{successMessage}</p>
              </div>
            )}

            <div className="auth-card">

              <div className="auth-box">
                <div className="card-heading">
                  <p>{isLogin ? "Welcome back" : "Create an account"}</p>
                  <h2>
                    {isLogin
                      ? "Sign in to Ashtang"
                      : `Register as ${role.charAt(0).toUpperCase() + role.slice(1)
                      }`}
                  </h2>
                </div>

                <form onSubmit={handleSubmit}>
                  {!isLogin && (
                    <div className="inline-inputs">
                      <input
                        type="text"
                        name="name"
                        placeholder="Full Name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                      <input
                        type="tel"
                        name="phone"
                        placeholder="Phone"
                        value={formData.phone}
                        onChange={(e) => {
                          const val = e.target.value.replace(/\D/g, "").slice(0, 10);
                          handleChange({ target: { name: "phone", value: val } });
                        }}
                        maxLength="10"
                        pattern="[0-9]{10}"
                        title="Please enter a valid 10-digit phone number"
                        required
                      />
                    </div>
                  )}
                  <div className="input-field">
                    <label>Email</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="Enter your email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {!isLogin && (
                    <div className="input-field">
                      <CustomDropdown
                        label="Select Role"
                        value={role}
                        onChange={setRole}
                        options={[
                          { value: "receptionist", label: "Receptionist" },
                          { value: "doctor", label: "Doctor" },
                          { value: "sales", label: "Sales" },
                        ]}
                      />
                    </div>
                  )}

                  <div className="input-field">
                    <label>Password</label>
                    <div className="password-input-wrapper">
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="Enter password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                      />
                      <span
                        className="password-toggle-icon"
                        onClick={() => setShowPassword(!showPassword)}
                        style={{ cursor: "pointer" }}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                  </div>

                  {!isLogin && (
                    <div className="input-field">
                      <label>Confirm Password</label>
                      <div className="password-input-wrapper">
                        <input
                          type={showConfPassword ? "text" : "password"}
                          name="confPassword"
                          placeholder="Re-enter password"
                          value={formData.confPassword}
                          onChange={handleChange}
                          required
                        />
                        <span
                          className="password-toggle-icon"
                          onClick={() => setShowConfPassword(!showConfPassword)}
                          style={{ cursor: "pointer" }}
                        >
                          {showConfPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                      </div>
                    </div>
                  )}

                  <button
                    type="submit"
                    className="submit-btn"
                    disabled={loading}
                  >
                    {loading ? "Processing..." : isLogin ? "Login" : "Register"}
                  </button>
                </form>

                <p className="toggle">
                  {isLogin
                    ? "Don't have an account?"
                    : "Already have an account?"}{" "}
                  <span onClick={() => setIsLogin(!isLogin)}>
                    {isLogin ? "Register" : "Login"}
                  </span>
                </p>
              </div>

              <div className="support-note">
                Having trouble?{" "}
                <a
                  href={`https://mail.google.com/mail/?view=cm&fs=1&to=${SUPPORT_EMAIL}&su=${encodeURIComponent(
                    SUBJECT
                  )}&body=${encodeURIComponent(BODY)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Contact support
                </a>
              </div>

              <div className="auth-copyright">
                © {new Date().getFullYear()} NexGen Software Innovations LLP. All rights reserved.
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default AuthPage;
